<template>
  <div
    v-if="!hasPermission('edit clubdata') && !notes.length"
    style="padding: 0 25px"
  >
    Keine Einträge
  </div>
  <time-line
    v-else
    plain
    type="simple"
    :class="{
      'note-timeline': true,
      empty: notes.length < 2,
      'note-timeline--no-dates': topic === 'reference'
    }"
  >
    <time-line-item
      badge-type="success"
      :badge-icon="topic === 'reference' ? 'link' : 'notes'"
      inverted
      :class="{ note: true }"
      v-for="note in notes"
      :key="note.id"
    >
      <time
        slot="date"
        :datetime="note.created_at"
        v-if="topic !== 'reference'"
      >
        <md-datepicker
          v-if="note.new || note.edit"
          @input="
            e =>
              (note.created_at =
                toIsoDate(e) + ' ' + dateFilter(new Date(), 'HH:mm:ss'))
          "
          :value="toGermanDate(note.created_at)"
        />
        <template v-else>{{ toGermanDate(note.created_at) }}</template>
      </time>
      <validation-error :errors="apiValidationErrors.created_at" />
      <template slot="content">
        <md-field class="md-invalid" v-if="note.new || note.edit">
          <md-textarea
            placeholder="Neuer Eintrag"
            v-model="note.value"
            md-autogrow
          ></md-textarea>
          <validation-error :errors="apiValidationErrors.value" />
        </md-field>
        <span class="note-value" v-else>{{ note.value }}</span>
        <md-button
          v-if="note.new || note.edit"
          :disabled="note.value === '' ? true : false"
          class="md-success"
          @click="updateNote()"
          style="float: right"
          >Einfügen</md-button
        >
      </template>
    </time-line-item>
  </time-line>
</template>
<style scoped lang="scss">
.note-timeline--no-dates ::v-deep .timeline {
  .timeline-badge {
    left: 25px;
  }
  &:before {
    display: none;
  }
  .timeline-panel {
    width: calc(100% - 80px);

    @media (max-width: 800px) {
      width: 100%;
    }
  }
}
.note-value {
  white-space: pre-wrap;
}
.note-timeline {
  max-width: 100%;
  width: 700px;
  padding: 0px 20px;
  height: 100%;
  overflow: auto;
  margin: 0;
  padding-top: 2px;

  ::v-deep .timeline-simple {
    margin: 0;
    padding: 0;
  }

  &.empty ::v-deep .timeline-simple:before {
    display: none;
  }
}
.note {
  ::v-deep .md-field {
    margin: 0;
    width: 100%;
  }

  ::v-deep .md-datepicker {
    width: 62%;
    margin: 0;

    * {
      cursor: pointer;
    }

    @media (max-width: 800px) {
      width: 100%;
    }

    input {
      color: #000;
      font-weight: inherit;
      padding: 0;
      margin: 0;
    }

    &:before,
    &:after {
      width: 100%;
    }

    .md-date-icon,
    .md-clear {
      display: none;
    }
  }
}
</style>
<script>
import { TimeLine, TimeLineItem, Badge } from "@/components";
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
export default {
  components: {
    ValidationError,
    TimeLine,
    TimeLineItem
  },

  mixins: [formMixin],

  data() {
    return {
      loading: false,
      saving: false,
      newNote: null
    };
  },
  props: {
    memberId: {
      required: true,
      type: String,
      default: null
    },
    topic: {
      type: String,
      default: "member"
    }
  },
  watch: {
    memberId: {
      handler(memberId) {
        if (memberId) {
          this.loading = true;
          this.$store.dispatch("members/get", memberId).then(() => {
            this.loading = false;
          });
          this.resetNewNote();
        }
      },
      immediate: true
    }
  },
  computed: {
    notes() {
      let notes = [];
      if (
        this.$store.getters["members/member"] &&
        this.$store.getters["members/member"].member_notes &&
        !this.loading
      ) {
        notes = this.$store.getters["members/member"].member_notes.filter(
          mn => mn.topic === this.topic
        );
      }
      if (this.hasPermission("edit clubdata") && this.newNote) {
        notes = [this.newNote, ...notes];
      }
      return notes;
    }
  },
  methods: {
    resetNewNote() {
      this.newNote = {
        new: true,
        type: "member-notes",
        topic: this.topic,
        member_id: this.memberId,
        value: "",
        created_at:
          this.toIsoDate(new Date()) +
          " " +
          this.dateFilter(new Date(), "HH:mm:ss")
      };
    },
    async updateNote() {
      try {
        await this.$store.dispatch("member_notes/add", this.newNote);
        this.setApiValidation([]);
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Ein Fehler ist aufgetreten!"
        );
        if (e.response) {
          this.setApiValidation(e.response.data.errors);
        }
        return;
      }
      await this.$store.dispatch("members/get", this.memberId);
      this.resetNewNote();
    }
  }
};
</script>
<style></style>
